<!-- 编辑零部件 -->
<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="400" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form"
                    :rules="rules" class="userFrom">
                    <el-form-item :label="t('maintenance.partName')" prop="name">
                        <el-input v-model="state.form.name" />
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    reactive,
    ref,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw,
    onMounted,
} from "vue";
import { ElMessage } from "element-plus";
import { planSaveApi } from "@/api/system/maintenance.js";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyAddSpareRules } from "@/utils/maintenanceListI18n.js";

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "",
    },
    device_id: {
        type: Number,
        default: 0,
    }
});

const rules = reactive({
    name: [{ required: true, message: "", trigger: "blur" }],
});

const applyLabels = () => {
    applyAddSpareRules(rules);
};
const { t } = usePageI18n(applyLabels);

const state = reactive({
    dialogVisible: false,
    form: {
        "id": 0,
        "name": "",
    }
});

const open = (node) => {
    state.dialogVisible = true;
    if(node?.id) {
        state.form = {
            "id": node.id,
            "name": node.name,
        }
    }
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = {
                ...toRaw(state.form),
                device_id: props.device_id
            }
            planSaveApi(JSON.stringify(params)).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('common.success'))
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "name": "",
                    }
                    emit('refresh')
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 100px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    margin-bottom: 0;
}
</style>
